import { useContext, useEffect, useRef } from "react";
import AuthContext from "./authProvider";

/**
 * Parceiro logado ANTES de o admin atribuir a loja fica com `user.store` vazio na
 * sessão até o próximo bootstrap/refresh (até 3h). Nesse estado o admin-ui mostrava
 * "Você não possui um reino parceiro" e chegou a criar pedido sem loja (incidente
 * 2026-09-24, hub ZN TCG). Aqui, ao entrar na área do parceiro sem loja, forçamos um
 * refresh silencioso (sem tela de loading) para reidratar o usuário uma única vez.
 */
export default function usePartnerStoreSync() {
    const { user, retrieveRefreshToken } = useContext(AuthContext);
    const attempted = useRef(false);

    useEffect(() => {
        if (attempted.current) return;
        if (!user?.roles?.includes("partner") || user?.store) return;
        attempted.current = true;
        retrieveRefreshToken?.(undefined, { silent: true });
    }, [user, retrieveRefreshToken]);
}
